import { useMediaQuery, useTheme } from '@material-ui/core';
export const useScreen = () => {
  const { breakpoints } = useTheme();
  const mediaQueryOptions = { noSsr: true };

  const xs = useMediaQuery(breakpoints.up('xs'), mediaQueryOptions);
  const sm = useMediaQuery(breakpoints.up('sm'), mediaQueryOptions);
  const md = useMediaQuery(breakpoints.up('md'), mediaQueryOptions);
  const lg = useMediaQuery(breakpoints.up('lg'), mediaQueryOptions);
  const xl = useMediaQuery(breakpoints.up('xl'), mediaQueryOptions);

  return { xs: !!xs, sm: !!sm, md: !!md, lg: !!lg, xl: !!xl, isMobile: !lg };
};
